import React, { useMemo } from 'react';
import { BsLink45Deg } from 'react-icons/bs';
import { Flex, HStack, Icon, IconButton, Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../../../../../../constants/cypressIds';
import { getDateObject, getDateString } from '../../../../../../../../../../../../../utils/dateUtil';

import BaseDocumentCell from './BaseDocumentCell';
import ExpirationDateCellPopover from './ExpirationDateCellPopover';

const ExpirationDateCell = ({ document }) => {
  const expirationDate = useMemo(() => {
    if (!document) return null;

    const dates = [...(document.policies ?? []), ...(document.expirations ?? [])]
      .map(item => getDateObject(item.expiresAt))
      .filter(Boolean)
      .map(date => date.getTime());

    return dates.length ? getDateString(new Date(Math.min(...dates)), 'MM/DD/YYYY') : 'N/A';
  }, [document]);

  if (!document) return null;

  if (!document.policies?.length && !document.expirations?.length) {
    return (
      <Text color="greyScale.600" key={document.id} whiteSpace="nowrap">
        N/A
      </Text>
    );
  }

  return (
    <HStack alignItems="center" data-cy={CypressIds.documentExpiredSection(document.id)} justifyContent="space-between" key={document.id}>
      <Text color="greyScale.600" pt={0} whiteSpace="nowrap">
        {expirationDate}
      </Text>
      <Popover placement="bottom" trigger="hover">
        <PopoverTrigger>
          <Flex justifyContent="center">
            <IconButton
              data-cy={CypressIds.documentExpiredIconButton(document.id)}
              icon={<Icon as={BsLink45Deg} h={5} w={5} />}
              variant="textPrimary"
            />
          </Flex>
        </PopoverTrigger>
        <Portal>
          <PopoverContent>
            <PopoverBody overflow="auto" p={2}>
              <ExpirationDateCellPopover document={document} />
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>

    </HStack>
  );
};

ExpirationDateCell.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number,
    policies: PropTypes.arrayOf(PropTypes.shape({
      expiresAt: PropTypes.string,
      number: PropTypes.string
    })),
    expirations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      expiresAt: PropTypes.string
    }))
  })
};

export default BaseDocumentCell(ExpirationDateCell);
